import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchHomeData } from "../redux/homeSlice";

const useHomeData = () => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.home);

  useEffect(() => {
    document.title = "Obsessions - Home Page";

    // Only fetch if data is not already loaded
    if (!data) {
      dispatch(fetchHomeData());
    }
  }, [dispatch, data]);

  return { data, loading, error };
};

export default useHomeData;
